import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import injectSheet from 'react-jss';
import Typography from '../Typography';

function ScheduleEvent({ classes, data, styles }) {
  const { title, speaker, place, track, onClick } = data;
  return (
    <div className={classNames(classes.root, onClick && classes.clickable)} onClick={onClick}>
      <span className={classes.colorSign} style={{ backgroundColor: track && track.color }} />
      <div className={classes.textWrapper} style={styles.dividers}>
        <Typography component="h3" type="title" style={{ ...styles.colors.title, ...styles.talk }}>
          {title}
        </Typography>
        <Typography component="p" type="body2" style={{ ...styles.colors.text, ...styles.detail }}>
          {speaker}
        </Typography>
        <Typography component="p" style={{ ...styles.colors.text, ...styles.detail }}>
          {place}
        </Typography>
      </div>
    </div>
  );
}

ScheduleEvent.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  styles: PropTypes.object,
  onClick: PropTypes.func,
};

ScheduleEvent.defaultProps = {
  styles: null,
  onClick: null,
};

const stylesheet = theme => ({
  root: {
    width: '100%',
    marginBottom: 0.5 * theme.spacing.unit,
    display: 'flex',
    '&:last-of-type': {
      marginBottom: 0,
    },
    '& div': {
      flexGrow: 1,
      borderBottom: `2px solid`,
      paddingLeft: 2 * theme.spacing.unit,
      marginTop: theme.spacing.unit,
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 1.5 * theme.spacing.unit,
        marginTop: 1.5 * theme.spacing.unit,
      },
    },
    '& span': {
      flexShrink: 0,
      width: 2 * theme.spacing.unit,
      backgroundColor: theme.palette.common.faintBlack,
      [theme.breakpoints.down('sm')]: {
        width: theme.spacing.unit,
      },
    },
    '& h3': {
      lineHeight: 1.2,
      marginBottom: 0.5 * theme.spacing.unit,
      [theme.breakpoints.down('sm')]: {
        fontSize: 20,
      },
    },
    '& p': {
      fontSize: 20,
      lineHeight: 1.33,
      [theme.breakpoints.down('sm')]: {
        fontSize: 16,
        marginBottom: theme.spacing.unit,
      },
      '&:last-of-type': {
        marginBottom: theme.spacing.unit,
      },
    },
  },
  clickable: {
    cursor: 'pointer',
    transition: theme.transitions.create('background-color'),
    '&:hover': {
      backgroundColor: theme.palette.common.faintBlack,
    },
  },
});

export default injectSheet(stylesheet)(ScheduleEvent);



// WEBPACK FOOTER //
// ./src/site-render/src/ScheduleSection/ScheduleEvent.js